'use client'

import React, { useMemo } from 'react'
import { SocialShareButtonsProps } from './SocialShareButtons.interface'
import { FaFacebookF, FaXTwitter, FaLinkedinIn } from 'react-icons/fa6'
import styles from './SocialShareButtons.module.scss'

const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({ title, url, className }) => {
  const shareUrls = useMemo(() => {
    // Only encode the parameters, not the base URLs
    const encodedTitle = encodeURIComponent(title)
    const encodedUrl = encodeURIComponent(url)

    return [
      {
        name: 'X',
        icon: FaXTwitter, // Item is the component itself
        href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      },
      {
        name: 'LinkedIn',
        icon: FaLinkedinIn,
        href: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`,
      },
      {
        name: 'Facebook',
        icon: FaFacebookF,
        href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      },
    ]
  }, [title, url])

  return (
    <div className={`${className || ''} leading-[125%] flex items-end mt-2.5 md:mt-0`}>
      <span
        className={`flex mr-4 font-medium text-[14px] tracking-[1.4px] uppercase font-dm-mono text-[#66748f] `}
      >
        SHARE
      </span>
      <div className={styles.shareIcons}>
        {shareUrls.map((item) => {
          const IconComponent = item.icon

          return (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Share on ${item.name}`}
              className={styles.shareButton}
            >
              <IconComponent size={20} />
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default SocialShareButtons
